let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kGRsy")).then(() => parcelRequire('biSZA'));